import styled from '@emotion/styled';
import { Css, ITheme, IUrlLinkItem, themed } from '@/ui';
import { getLinkPropsForUrl } from '../../../navigation/getLinkPropsForUrl';
import { RouterLink } from '../link/RouterLink';

export const StyledFooterLinkList = styled.ul<{}, ITheme>`
	list-style: none;
	padding: 0;
	margin: 0;

	li {
		margin-bottom: ${Css.pxToRemFromTheme(16)};
		padding-left: 0;
		font-weight: 400;
		line-height: normal;

		&:last-of-type {
			margin-bottom: 0;
		}

		a {
			color: ${themed(({ color }) => color.text.light)};
			text-decoration: none;

			&:hover {
				text-decoration: underline;
				color: ${themed(({ typography }) => typography.link.hover.color)};
			}
		}
	}
`;

export interface IFooterLinkListProps {
	links: IUrlLinkItem[];
}

export function FooterLinkList({ links }: IFooterLinkListProps) {
	return (
		<StyledFooterLinkList>
			{links?.map((link) => (
				<li key={link.key}>
					<RouterLink {...getLinkPropsForUrl(link.url)}>
						{link.title}
					</RouterLink>
				</li>
			))}
		</StyledFooterLinkList>
	);
}
